module.exports = __webpack_public_path__ + "logo_42-12625cca1bdcd16dbf8ea0a69f85ac8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_42.png
// module id = 1135
// module chunks = 0 1